module.exports = __webpack_public_path__ + "static/media/Search.aa51cd25.svg";